<atx-infinite-scroll (scrolled)="onScroll()">
  @if (baskets$ | async; as baskets) { @for (basket of baskets; track
  trackByBasketId($index, basket)) {
  <epc-basket-selector
    [basket]="basket"
    [isActive]="isActive(basket.id)"
  ></epc-basket-selector>
  } }
</atx-infinite-scroll>
